import configDataFn from '@/baseData/enterpriseOrder/manageList'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const jumpDetail = (query) => {
    this.$router.push({
      path: '/workbench/entOrder/detail',
      query,
    })
  }
  const operate = {
    name: 'operate',
    columnProps: {
      label: '操作',
      width: 240,
      fixed: 'right',
    },
    type: 'operate',
    maxShowLength: operateMaxShowLength,
    getOperateList: ({ row }) => {
      const operateList = []
      operateList.push({ name: 'detail', label: '详情', action: () => jumpDetail({ id: row.id, tabType: 'enterpriseOrder' }) })
      return operateList
    },
  }
  const { configData } = configDataFn.call(this, { jumpDetail, dealWithData: this.dealWithData })
  configData.tableData.columns.push(operate)
  return { configData }
}
